/**
 * Context entries (§8.13, D183), fetched independently of whichever card asks for them —
 * same reasoning as `modelConfigs.ts`. Named `contextEntries`, not `context`, so it doesn't
 * collide with React's own `useContext` in anything that imports both.
 */

import { useCallback, useEffect, useState } from "react";
import { ApiError, api, type ContextEntry } from "./api";

export function useContextEntries(refreshKey?: number) {
  const [entries, setEntries] = useState<ContextEntry[]>([]);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    try {
      setEntries((await api.context()).context);
      setError(null);
    } catch (err) {
      if (err instanceof ApiError && err.isAuth) return;
      setError(err instanceof Error ? err.message : String(err));
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load, refreshKey]);

  return { entries, error, reload: load };
}
